import { createSelector } from '@reduxjs/toolkit';
import { entitiesSelector } from "./base";
export const sheetsSelector = createSelector(entitiesSelector, ({
  sheets
}) => sheets);
export const multiSectionIds = createSelector(sheetsSelector, sheets => sheets.map(({
  multi_section
}) => multi_section));
export const primarySheetsSelector = createSelector(sheetsSelector, multiSectionIds, (sheets, multiSectionIds) => sheets.filter(({
  section_id
}) => !multiSectionIds.includes(section_id)));
export const standardSheetSelector = createSelector(primarySheetsSelector, sheets => {
  const standardSheetTypeIds = [11];
  return sheets.filter(({
    sheet_type_id,
    multi_section
  }) => standardSheetTypeIds.includes(sheet_type_id) && !multi_section);
});
export const subSheetsSelector = createSelector(sheetsSelector, multiSectionIds, (sheets, multiSectionIds) => sheets.filter(({
  section_id
}) => multiSectionIds.includes(section_id)));
export const combinedSheetSelector = createSelector(primarySheetsSelector, subSheetsSelector, (primarySheets, subSheets) => {
  return primarySheets.map(sheet => {
    return {
      ...sheet,
      subSheets: subSheets.filter(({
        section_id
      }) => {
        return sheet.multi_section === section_id;
      }).map(({
        id
      }) => id)
    };
  });
});